import { render, staticRenderFns } from "./AsidePrizeInput.vue?vue&type=template&id=e1022a7c&scoped=true&"
import script from "./AsidePrizeInput.vue?vue&type=script&lang=js&"
export * from "./AsidePrizeInput.vue?vue&type=script&lang=js&"
import style0 from "./AsidePrizeInput.vue?vue&type=style&index=0&id=e1022a7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1022a7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
